import { render, staticRenderFns } from "./MyRankView.vue?vue&type=template&id=710da97d&scoped=true"
import script from "./MyRankView.vue?vue&type=script&lang=js"
export * from "./MyRankView.vue?vue&type=script&lang=js"
import style0 from "./MyRankView.vue?vue&type=style&index=0&id=710da97d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710da97d",
  null
  
)

export default component.exports